export default __webpack_public_path__ + "static/media/usdre-official-seal-150x150.27a91ee5.png";